import template from './template.html';
import './styles.css';

controller.$inject = ['$rootScope'];

export function controller($rootScope) {
    var vm = this;
    vm.selected = undefined;
    vm.select = select;
    vm.trackId = trackId;

    vm.sortToggle = sortToggle;
    const sorts = [
        'lastName',
        'firstName'
    ];

    function sortToggle() {
        const index = sorts.indexOf(vm.sort);
        if (index != -1 && index < sorts.length) {
            vm.sort = sorts[index+1];
        } else {
            vm.sort = sorts[0];
        }
    }

    function select(driver) {
        if (!driver || vm.selected && vm.selected.id === driver.id) {
            vm.selected = undefined;
        } else {
            vm.selected = driver;
        }
        $rootScope.$broadcast('driver-selected', vm.selected);        
    }

    function trackId(driver) {        
        const hours = driver.allocatedHours.total || 0;
        return driver.id + '#' + hours;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        data: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/driverlist/index.js